import { SecurityFindingKind, RecommendedAction, SecurityFindingSeverityLevel } from "$lib/models/base";
import { Timestamp } from "firebase/firestore";
import type { SecurityFinding } from "$lib/stores/orgSecurityFindings";

export const mockFindingsData: SecurityFinding[] = [
  {
    id: "MOCK-001",
    securityFindingId: "MOCK-001",
    securityFindingVersion: "1.0.0",
    securityFindingKind: SecurityFindingKind.ANOMALOUS_PERMISSIONS_ON_SENSITIVE_DOCUMENT,
    modified: Timestamp.fromDate(new Date()),
    severity: 0.99,
    severityLevel: SecurityFindingSeverityLevel.HIGH,
    confidence: 0.95,
    numberOfMisconfiguredPermissions: 5,
    numberOfImpactedPrincipals: 5,
    totalNumberOfPermissions: 10,
    totalNumberOfPrincipals: 10,
    system: "msgraph-v4",
    created: Timestamp.fromDate(new Date(Date.now() - 86400000)),
    resources: [
      {
        resourceId: "msgraph-v4:document:connection_1:doc_001",
        resourceVersion: "1.0",
        name: "Q4_Financial_Projections.xlsx",
        path: "/Finance/Reports/Executive/",
        link: "https://example.com/docs/Q4_Financial_Projections",
        owner: "finance.director@example.com",
        ownerType: "user",
        ownerEmail: "finance.director@example.com",
        isSensitive: true,
        createdAt: Timestamp.fromDate(new Date(Date.now() - 172800000)),
        modifiedAt: Timestamp.fromDate(new Date(Date.now() - 86400000)),
        sensitiveTopics: [
          { sensitiveTopic: "Confidential Financial Strategies", sensitivityScore: 0.95 },
          { sensitiveTopic: "Boardroom Decisions", sensitivityScore: 0.9 },
        ],
      },
    ],
    recommendations: [
      {
        anomalyScore: 0.95,
        principal: "temp_contractors",
        email: "contractor.jane@example.com",
        principalType: "group",
        recommendedAction: RecommendedAction.REVOKE,
      },
      {
        anomalyScore: 0.9,
        principal: "finance_team",
        email: "john.doe@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.85,
        principal: "executive_board",
        email: "executive.smith@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.8,
        principal: "auditors",
        email: "auditor.jane@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.75,
        principal: "legal_team",
        email: "legal.john@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
    ],
    sensitiveTopics: [
      { sensitiveTopic: "Confidential Financial Strategies", sensitivityScore: 0.95 },
      { sensitiveTopic: "Boardroom Decisions", sensitivityScore: 0.9 },
    ],
    status: "open",
  },
  {
    id: "MOCK-002",
    securityFindingId: "MOCK-002",
    securityFindingVersion: "1.0.0",
    securityFindingKind: SecurityFindingKind.ANOMALOUS_PERMISSIONS_ON_SENSITIVE_DOCUMENT,
    modified: Timestamp.fromDate(new Date()),
    severity: 0.85,
    severityLevel: SecurityFindingSeverityLevel.HIGH,
    confidence: 0.92,
    numberOfMisconfiguredPermissions: 3,
    numberOfImpactedPrincipals: 3,
    totalNumberOfPermissions: 8,
    totalNumberOfPrincipals: 8,
    system: "msgraph-v4",
    created: Timestamp.fromDate(new Date(Date.now() - 172800000)),
    resources: [
      {
        resourceId: "msgraph-v4:document:connection_1:doc_002",
        resourceVersion: "1.0",
        name: "IT_Infrastructure_Upgrade_Plan.pdf",
        path: "/IT/Strategic/Planning/",
        link: "https://example.com/docs/IT_Infrastructure_Upgrade_Plan",
        owner: "it.architect@example.com",
        ownerType: "user",
        ownerEmail: "it.architect@example.com",
        isSensitive: true,
        createdAt: Timestamp.fromDate(new Date(Date.now() - 259200000)),
        modifiedAt: Timestamp.fromDate(new Date(Date.now() - 172800000)),
        sensitiveTopics: [{ sensitiveTopic: "Critical Infrastructure Security Plans", sensitivityScore: 0.9 }],
      },
    ],
    recommendations: [
      {
        anomalyScore: 0.88,
        principal: "external_consultants",
        email: "consultant.jane@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.REVOKE,
      },
      {
        anomalyScore: 0.85,
        principal: "it_team",
        email: "it.john@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.82,
        principal: "project_managers",
        email: "pm.smith@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.8,
        principal: "security_team",
        email: "security.jane@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.78,
        principal: "operations_team",
        email: "ops.john@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
    ],
    sensitiveTopics: [{ sensitiveTopic: "Critical Infrastructure Security Plans", sensitivityScore: 0.9 }],
    status: "open",
  },
  {
    id: "MOCK-003",
    securityFindingId: "MOCK-003",
    securityFindingVersion: "1.0.0",
    securityFindingKind: SecurityFindingKind.ANOMALOUS_PERMISSIONS_ON_SENSITIVE_DOCUMENT,
    modified: Timestamp.fromDate(new Date()),
    severity: 0.5,
    severityLevel: SecurityFindingSeverityLevel.MEDIUM,
    confidence: 0.89,
    numberOfMisconfiguredPermissions: 4,
    numberOfImpactedPrincipals: 4,
    totalNumberOfPermissions: 6,
    totalNumberOfPrincipals: 6,
    system: "sharepoint",
    created: Timestamp.fromDate(new Date(Date.now() - 259200000)),
    resources: [
      {
        resourceId: "sharepoint:document:connection_2:doc_003",
        resourceVersion: "1.0",
        name: "Employee_Engagement_Survey_Results.xlsx",
        path: "/HR/Surveys/2024/",
        link: "https://example.com/docs/Employee_Engagement_Survey_Results",
        owner: "hr.analytics@example.com",
        ownerType: "user",
        ownerEmail: "hr.analytics@example.com",
        isSensitive: true,
        createdAt: Timestamp.fromDate(new Date(Date.now() - 345600000)),
        modifiedAt: Timestamp.fromDate(new Date(Date.now() - 259200000)),
        sensitiveTopics: [
          { sensitiveTopic: "Confidential Employee Feedback", sensitivityScore: 0.85 },
          { sensitiveTopic: "Internal Culture Assessments", sensitivityScore: 0.8 },
        ],
      },
    ],
    recommendations: [
      {
        anomalyScore: 0.82,
        principal: "department_managers",
        email: "manager.jane@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.REVOKE,
      },
      {
        anomalyScore: 0.8,
        principal: "hr_team",
        email: "hr.john@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.78,
        principal: "employee_relations",
        email: "relations.smith@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.76,
        principal: "survey_analysts",
        email: "analyst.jane@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
    ],
    sensitiveTopics: [
      { sensitiveTopic: "Confidential Employee Feedback", sensitivityScore: 0.85 },
      { sensitiveTopic: "Internal Culture Assessments", sensitivityScore: 0.8 },
    ],
    status: "open",
  },
  {
    id: "MOCK-004",
    securityFindingId: "MOCK-004",
    securityFindingVersion: "1.0.0",
    securityFindingKind: SecurityFindingKind.ANOMALOUS_PERMISSIONS_ON_SENSITIVE_DOCUMENT,
    modified: Timestamp.fromDate(new Date()),
    severity: 0.8,
    severityLevel: SecurityFindingSeverityLevel.HIGH,
    confidence: 0.97,
    numberOfMisconfiguredPermissions: 2,
    numberOfImpactedPrincipals: 2,
    totalNumberOfPermissions: 5,
    totalNumberOfPrincipals: 5,
    system: "sharepoint",
    created: Timestamp.fromDate(new Date(Date.now() - 345600000)),
    resources: [
      {
        resourceId: "sharepoint:document:connection_2:doc_004",
        resourceVersion: "1.0",
        name: "Vendor_Security_Assessment_2024.docx",
        path: "/Security/Vendor_Reviews/",
        link: "https://example.com/docs/Vendor_Security_Assessment_2024",
        owner: "security.team@example.com",
        ownerType: "user",
        ownerEmail: "security.team@example.com",
        isSensitive: true,
        createdAt: Timestamp.fromDate(new Date(Date.now() - 432000000)),
        modifiedAt: Timestamp.fromDate(new Date(Date.now() - 345600000)),
        sensitiveTopics: [{ sensitiveTopic: "Vendor Risk and Compliance Reports", sensitivityScore: 0.9 }],
      },
    ],
    recommendations: [
      {
        anomalyScore: 0.93,
        principal: "procurement_team",
        email: "procurement.jane@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.REVOKE,
      },
      {
        anomalyScore: 0.9,
        principal: "vendor_management",
        email: "vendor.smith@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.88,
        principal: "risk_assessment",
        email: "risk.john@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
    ],
    sensitiveTopics: [{ sensitiveTopic: "Vendor Risk and Compliance Reports", sensitivityScore: 0.9 }],
    status: "open",
  },
  {
    id: "MOCK-005",
    securityFindingId: "MOCK-005",
    securityFindingVersion: "1.0.0",
    securityFindingKind: SecurityFindingKind.ANOMALOUS_PERMISSIONS_ON_SENSITIVE_DOCUMENT,
    modified: Timestamp.fromDate(new Date()),
    severity: 0.5,
    severityLevel: SecurityFindingSeverityLevel.MEDIUM,
    confidence: 0.91,
    numberOfMisconfiguredPermissions: 3,
    numberOfImpactedPrincipals: 3,
    totalNumberOfPermissions: 4,
    totalNumberOfPrincipals: 4,
    system: "onedrive",
    created: Timestamp.fromDate(new Date(Date.now() - 432000000)),
    resources: [
      {
        resourceId: "onedrive:document:connection_3:doc_005",
        resourceVersion: "1.0",
        name: "Office_Expansion_Budget_2024.xlsx",
        path: "/Finance/Planning/Facilities/",
        link: "https://example.com/docs/Office_Expansion_Budget_2024",
        owner: "facilities.planning@example.com",
        ownerType: "user",
        ownerEmail: "facilities.planning@example.com",
        isSensitive: true,
        createdAt: Timestamp.fromDate(new Date(Date.now() - 518400000)),
        modifiedAt: Timestamp.fromDate(new Date(Date.now() - 432000000)),
        sensitiveTopics: [
          { sensitiveTopic: "Strategic Budget Allocations", sensitivityScore: 0.88 },
          { sensitiveTopic: "Confidential Expansion Plans", sensitivityScore: 0.85 },
        ],
      },
    ],
    recommendations: [
      {
        anomalyScore: 0.87,
        principal: "facilities_committee",
        email: "facilities.jane@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.REVOKE,
      },
      {
        anomalyScore: 0.85,
        principal: "budget_analysts",
        email: "budget.john@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
      {
        anomalyScore: 0.83,
        principal: "finance_team",
        email: "finance.smith@example.com",
        principalType: "user",
        recommendedAction: RecommendedAction.UNCHANGED,
      },
    ],
    sensitiveTopics: [
      { sensitiveTopic: "Strategic Budget Allocations", sensitivityScore: 0.88 },
      { sensitiveTopic: "Confidential Expansion Plans", sensitivityScore: 0.85 },
    ],
    status: "open",
  },
];
